// Javascript for simple form where a user changes their email address
// TODO convert to generic classes - although this one uses a different way of listing errors.
// @author Matthew Norris

const AjaxFormErrorHandler = require('Scripts/common/ajax-form-error-handler');

module.exports = function ChangeEmail() {
	this.init = function() {
		self.errorHandler = new AjaxFormErrorHandler();
		self.form = $("#form-change-email");
		self.form.on("submit", self.post);
		self.submit = $("#change-email-submit");
		self.submit.data("text", self.submit.val());
	}

	this.post = function() {
		self.submit.val("Processing...").addClass("disabled");
		$.ajax("/account/email-settings", {
			method: "POST",
			data: self.form.serialize()
		}).done(self.receiveResponse);
		return false;
	}
	this.receiveResponse = function(response) {
		if (self.errorHandler.handleErrors(response)) {
			// there's something wrong with what the user submitted
			// list the errors at the top of the form, looks nicer than next to the fields.
			self.submit.val(self.submit.data("text")).removeClass("disabled");
			$("#oops").hide();
			$(".password_oops-message").hide();
			for (var i = 0; i < response.errors.length; i++) {
				var error = response.errors[i];
				$("#oops-messages_"+error["fieldName"]).text(error["message"]).show();
			}
			$("#oops").slideDown(self.fadeInMs);
		} else {
			document.location = "/dashboard"
		}
	}
	var self = this;
	self.init();
};
